import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/booking-calcom-setup/booking-calcom-setup/calcom/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
